const list = [
  {
    id: 2,
    name: '中职',
    imageSrc: 'image/solution/solution-wx-zz.png',
    desc: '我们已成功为多所知名中职学校部' +
      '署了高效稳定的无线网络环境，并与教' +
      '育行业的多个重要合作伙伴建立了长期' +
      '合作关系，共同推动教育信息化发展。',
  },
  {
    id: 1,
    name: '高校',
    imageSrc: 'image/solution/solution-school.png',
    desc: '公司凭借多年在教育行业无线网络' +
      '部署的丰富经验，已成为高校优选的网' +
      '络解决方案提供商，赢得了广泛的客户' +
      '认可和行业内的良好口碑。',
  },

  {
    id: 3,
    name: '工地',
    imageSrc: 'image/solution/solution-gongdi.png',
    desc: '公司的无线网络解决方案在保证高' +
      '性能的同时，还注重成本控制，为工地' +
      '提供性价比高的网络服务，降低总体运' +
      '营成本。',
  },
  {
    id: 4,
    name: '工厂',
    imageSrc: 'image/solution/solution-factory.png',
    desc: '我们公司专注于为工厂提供高度定' +
      '制化的无线网络解决方案，针对不同类' +
      '型的工业环境和生产需求，设计出既高' +
      '效又稳定的无线网络解决方案。',
  },

]

export default list



// WEBPACK FOOTER //
// ./src/pages/solution/solutionsData.js